import { EmptyDataMessage } from '@/common/components/EmptyDataMessage'
import { Pagination } from '@/common/components/Table/pagination'
import { twMerge } from 'tailwind-merge'
import { SelectEquipmentGridItem } from './SelectEquipmentGridItem'
import { EquipmentData } from '@/features/equipments/types/equipments.type'
import { EquipmentsGridLoading } from '@/features/equipments/components/EquipmentGridLoading'

interface SelectEquipmentGridTableProps {
  className?: string
  companyEquipments: EquipmentData[]
  page: number
  totalPages: number
  totalCount?: number
  setPage?: React.Dispatch<React.SetStateAction<number | undefined>>
  isLoadingData: boolean
  hasSelection?: boolean
}

export const SelectEquipmentGridTable = ({
  className,
  companyEquipments,
  page,
  totalPages,
  totalCount,
  setPage,
  isLoadingData,
}: SelectEquipmentGridTableProps) => {
  return isLoadingData || !!companyEquipments.length ? (
    <div>
      <div
        data-testid="equipments_grid"
        className={twMerge(
          'grid grid-cols-[repeat(auto-fill,minmax(216px,1fr))] gap-4 overflow-y-auto max-h-[calc(100vh-358px)]',
          className,
        )}
      >
        {isLoadingData ? (
          Array(20)
            .fill(0)
            .map((_, index) => <EquipmentsGridLoading key={index} />)
        ) : (
          <>
            {companyEquipments.map((equipment) => (
              <SelectEquipmentGridItem
                key={equipment.id}
                equipment={equipment}
              />
            ))}
          </>
        )}
      </div>

      <div
        className={twMerge(
          'w-full px-4 py-2 bg-white-200 rounded-b-lg flex justify-between items-center',
          typeof totalCount === 'undefined' && 'justify-end',
        )}
      >
        {typeof totalCount !== 'undefined' ? (
          <p className="text-xs italic font-light">
            Mostrando {companyEquipments.length} resultados de {totalCount}
          </p>
        ) : null}
        {setPage && (
          <Pagination
            currentPage={Number(page)}
            setPage={setPage}
            totalPages={totalPages}
          />
        )}
      </div>
    </div>
  ) : (
    <EmptyDataMessage className={className} />
  )
}
